import React, {useContext, useEffect, useState, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';

import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import {KeycloakContext} from "../context/KeycloakContext";
import {Link} from "react-router-dom";
import FormFilterDropdown from "./Form/FormFilterDropdown";
import { listMeasurements } from "../helpers/ApiRequests";
import { formatLocalDateToISO } from "../helpers/FormatDate";
import {FlashingBorder} from "../Shared/FlashingBorder";
import { useMediaQuery } from 'react-responsive'; // Importar useMediaQuery desde react-responsive



const Readings = () => {
    const { kc } = useContext( KeycloakContext )
    const keycloak = kc;

    const [messungen, setMessungen] = useState([]);
    const [loading, setLoading] = useState(true);

    const { t,i18n } = useTranslation();
    const refreshButtonRef = useRef(null);  // Create a ref for the refresh button

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [measurementToDelete, setMeasurementToDelete] = useState(null);

    // Pagination state
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    // Filter state
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [referenceNameFilter, setReferenceNameFilter] = useState('');
    const [isVisible, setIsVisible] = useState(true);
    const isTabled = useMediaQuery({ maxWidth: 1024 }); // Define el ancho máximo para considerar como móvil
    const widthColumn = isTabled ? 'auto' : 500;


    const getListMeasurements = async () => {
        if (keycloak && keycloak.token) {
            const page = first / rows + 1;
            console.log("Fetch - Page:", page, "Rows:", rows);

            // Build query parameters for filters
            const params = new URLSearchParams();
            params.append('page', page);
            params.append('size', rows);
            // console.log('dateformat--------------------------------->', formatLocalDateToISO(startDate))
            if (startDate) params.append('start_date', formatLocalDateToISO(startDate));
            if (endDate) params.append('end_date', formatLocalDateToISO(endDate));
            if (referenceNameFilter) params.append('referencename', referenceNameFilter);

            const response = await listMeasurements(kc, params)
            if (response) {
                console.info(response);
                setMessungen(response.messungen);
                setTotalRecords(response.totalCount);
                setLoading(false);
            } else {
                setLoading(false);

            };
        }
    };

    useEffect(() => {
        getListMeasurements();
    }, [keycloak, first, rows, startDate, endDate, referenceNameFilter]);

    const confirmDelete = (messungId) => {
        setMeasurementToDelete(messungId);
        setDeleteConfirmation(true);
    };

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    const handleRefresh = () => {
        setFirst(0);
        getListMeasurements();
        refreshButtonRef.current?.blur(); // Remove focus from the button

    };
    const deleteMeasurement = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/delete-measurement`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
            body: JSON.stringify({ measurement_uuid: measurementToDelete }),
        })
            .then(response => {
                if (response.ok) {
                    setMessungen(messungen.filter(messung => messung.id !== measurementToDelete));
                    console.log("Measurement deleted successfully");
                } else {
                    console.error("Error deleting measurement");
                }
            })
            .catch(error => console.error('Error:', error));

        setDeleteConfirmation(false);
    };

    const renderDeleteConfirmation = () => (
        <Dialog
            className="border rounded-md"
            visible={deleteConfirmation}
            onHide={() => setDeleteConfirmation(false)}
            header={t('Confirm_Deletion_header')}
            footer={
                <div className="flex justify-around">
                    <Button label={t('No')} onClick={() => setDeleteConfirmation(false)} />
                    <Button label={t('Yes')} onClick={deleteMeasurement} />
                </div>
            }>
            <p>{t('ConfirmDeletionBody')}</p>
        </Dialog>
    );


    if (loading) {
        return <div>{t('loadingString')}</div>;
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="button-group text-center xl:text-right flex justify-content-end ">
                <div className="mx-1">
                    <Button
                        icon="pi pi-trash text-base"
                        className="delete-button"
                        onClick={() => confirmDelete(rowData.id)}
                    />
                </div>
            </div>
        );
    };

    const newDateValues = (event) => {
        setStartDate(event[0])
        setEndDate(event[1])
    }

    const newReferenceName = (event) => {
        setReferenceNameFilter(event)
    }

    const referenceTemplate = (rowData) => {
        return (
            <Link className='reference-column' to={`/patient/${rowData.id}`} >{rowData.referencename}</Link>
        )
    }
    const mimetikaIdTemplate = (rowData) => {
        return (
            <Link className='reference-column' to={`/patient/${rowData.id}`} >{rowData.id}</Link>
        )
    }


    const StatusTemplate = (rowData) => {
        switch (rowData.status) {
            case 'new':
                return (
                    <Link className='reference-column' to={`/patient/${rowData.id}`} >{<i className="pi pi-circle-on"></i>}</Link>
                )
            case 'markedForOrdering':
                return (
                    <Link className='reference-column' to={`/patient/${rowData.id}`} >{ <i className="pi pi-check-circle"></i>}</Link>
                )
            case 'ordered':
                return (
                    <Link className='reference-column' to={`/patient/${rowData.id}`} >{ <i className="pi pi-check"></i>}</Link>
                )
            default:
                return <span>-</span>;  // Default when no status is set
        }
    };


    const handleAnimationEnd = () => {
        setIsVisible(false);
    };

    // const isTabled = useMediaQuery({ maxWidth: 404 }); // Define el ancho máximo para considerar como móvil

    return (
        <>

            <div className="container-page-list mx-auto relative z-1 p-1 overflow-y-hidden overflow-x-hidden">
                <div className="container-flash-border border-1 border-white pt-3 pr-2 pl-2 pb-0 sm:pt-4 sm:pr-4 sm:pl-4 overflow-hidden ">
                    {isVisible && (
                        <>
                            <FlashingBorder flash={'flash-border'} onAnimationEnd={handleAnimationEnd} />
                        </>
                    )}
                    <div className="flex flex-wrap sm:flex justify-content-between">
                        <div className="text-xl my-1 mr-3 lg:my-2 lg:my-0 lg:text-3xl text-white uppercase">{t('All readings')}
                        <Button icon="pi pi-refresh" onClick={handleRefresh} ref={refreshButtonRef} className="ml-2 p-button-rounded p-button-text p-button-plain" aria-label="Refresh" />
                        </div>
                        <div className="pb-2 my-1 lg:my-2 lg:pb-2 lg:my-0">
                            <FormFilterDropdown  newDateValues={ newDateValues } newReferenceName={ newReferenceName } />
                        </div>
                    </div>

                    <DataTable className="table-measures mt-1 sm:mt-4" value={messungen} responsiveLayout="scroll" scrollable>
                        <Column field="timestamp" header={t('MeasurementTimePoint')}
                                body={(rowData) => new Date(rowData.timestamp).toLocaleString(i18n.language)}  style={{ width: '20%' }}/>
                        <Column body={mimetikaIdTemplate} field="id" header={t('MeasurementUUID')} style={{ width: '30%' }} />
                        <Column body={referenceTemplate}  header={t('ReferenceName')} style={{ width: '30%' }}/>
                        <Column body={StatusTemplate}  header={t('Status')} style={{ width: '10%' }}/>

                        <Column body={actionBodyTemplate} style={{ width: '10%' }}/>
                    </DataTable>
                    {renderDeleteConfirmation()}
                </div>
            </div>
            <Paginator
                first={first}
                rows={rows}
                p-dialog-footer = "true"
                totalRecords={totalRecords}
                onPageChange={onPageChange}
                template={{ layout: 'PrevPageLink PageLinks NextPageLink' }}
                className="mx-auto mt-3 sm:my-4"
            />
        </>

);
}

export default Readings;
